import PropTypes from 'prop-types';
import { Component } from 'react';

const BLUR_RADIUS = 6;
const ASPECT_RATIO = 9 / 16;

class InterviewTilePreview extends Component {
	static getImageWidth(url) {
		return new Promise((resolve) => {
			const image = new Image();
			image.onload = function () {
				resolve({
					width: this.width,
					height: this.height,
				});
			};
			image.src = url;
		});
	}

	constructor(props) {
		super(props);

		this.state = {
			width: undefined,
			height: undefined,
		};

		InterviewTilePreview.getImageWidth(this.props.previewUrl).then(({ width, height }) => {
			this.setState({ width, height });
		});
	}

	/**
	 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
	 */
	render() {
		const width = this.state.width || 0;
		const height = this.state.height || 0;

		let viewportWidth, viewportHeight;

		if (height >= width * ASPECT_RATIO) {
			viewportWidth = width;
			viewportHeight = width * ASPECT_RATIO;
		} else {
			viewportHeight = height;
			viewportWidth = height / ASPECT_RATIO;
		}

		return (
			<div className="grid-2__tile__type-interview__preview">
				<svg width="100%" viewBox={`0 0 ${viewportWidth} ${viewportHeight}`} className="grid-2__tile__type-interview__preview-image">
					<defs>
						<filter id="svgBlur">
							<feGaussianBlur stdDeviation={BLUR_RADIUS} />
						</filter>
					</defs>
					<image
						filter={this.props.blur ? 'url(#svgBlur)' : null}
						xlinkHref={this.props.previewUrl}
						xlinkTitle={this.props.title}
						width={viewportWidth}
						height={viewportHeight}
						preserveAspectRatio="xMidYMid slice"
					/>
				</svg>
			</div>
		);
	}
}

InterviewTilePreview.propTypes = {
	previewUrl: PropTypes.string.isRequired,
	title: PropTypes.string,
	blur: PropTypes.bool,
};

InterviewTilePreview.defaultProps = {
	title: '',
	blur: false,
};

export default InterviewTilePreview;
